import React, {useState} from 'react';
import Span from "../../../system/components/span";
import Icon from "../../../system/components/icon";
import {useUpdateEffect} from "primereact/hooks";

function QuickCreateInputText({placeholder, value, icon, onKeyDownEnter, className="pr-3 p-2 bg-transparent"}) {
    const [focused, setFocused] = useState(false);

    return(
        <Span inputValue={value} focused={focused} inputClassName={`text-xs flex align-items-center w-full ${className}`} spanClassName={`text-xs flex align-items-center ${className}`} setFocused={setFocused} onKeyDownEnter={(e)=>{onKeyDownEnter?.(e); }}>
            <Icon icon={icon} className="text-lg text-500 pl-1"/>
            {placeholder}
        </Span>
    )
}


export default QuickCreateInputText;